import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { LieferArtLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';

interface LieferArtProps {
    label?: string;
    disabled?: boolean;
    value: string;
    menuPlacement?: MenuPlacement;
    addAll?: boolean;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange?: (newValue: string) => void;
}

const allOption = { value: '__all__', label: 'Alle Lieferarten' };

export const LieferArt: React.FC<LieferArtProps> = ({
    label = 'Lieferart',
    value,
    disabled = false,
    menuPlacement = 'bottom',
    addAll = false,
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];

        if (addAll) {
            list.push(allOption);
        }

        Object.keys(LieferArtLabel).forEach((key) => {
            list.push({
                value: key,
                label: LieferArtLabel[key],
            });
        });

        if (allowEmpty) {
            list.push({ value: '', label: '' });
        }

        return list;
    }, [addAll, allowEmpty]);

    const selectedOption = React.useMemo(() => {
        if (value === '__all__') {
            return allOption;
        }

        if (value) {
            return {
                value,
                label: LieferArtLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <Select
                name="status"
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={selectedOption}
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    if (onChange) {
                        onChange(option?.value || '');
                    }
                }}
                placeholder={renderLabel === 'placeholder' ? 'Lieferart' : ''}
            />
        </>
    );
};
